export const changeThemeColor = ( color: string ) => document.querySelector( "meta[name='theme-color']" )?.setAttribute( 'content', color );

export const validationEmail = ( email: string ) => {

  if ( /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,})+$/.test( email ) && !/.con$/.test( email ) ) {

    return true;

  }

  return false;

};
